import loadable from '@loadable/component';

const Component = loadable(() => import('./Home'));

export default Component;
